var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length > 0)?_c('section',{staticClass:"featured-good-list"},[_c('h2',[_vm._v("Лучшие предложения")]),_vm._l((_vm.list),function(item){return _c('featured-good-list-item',{key:`id-${item.itemId}`,attrs:{"id":item.itemId,"image":item.image.files.large,"title":item.title,"link":item.link}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }